const classRegexCache = {};
export function classRegex(className: string): RegExp {
	if (!classRegexCache[className]) {
		classRegexCache[className] = new RegExp('(\\s|^)' + className + '(\\s|$)');
	}
	return classRegexCache[className];
}
